<!--
 * @Author: 裴纬华
 * @Date: 2021-12-27 15:52:32
 * @LastEditors: 裴纬华
 * @LastEditTime: 2021-12-28 16:18:01
 * @Description: 资产负债表
-->
<template>
<div>
      <div :class="[preClass ,'container']">
        <van-tabs v-model="activeName" :border='false' :swipeable='true' :sticky='true'>
            <van-tab title="资产" > <base-table :data="tableData" :headers='headers' ></base-table> </van-tab>
            <van-tab title="负债" > <base-table :data="tableData1" :headers='headers1' ></base-table></van-tab>
      </van-tabs>

    </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      preClass: "balance-sheet",
      activeName:0,
      tableData:[],
      tableData1:[],
      headers: ["资产", "期末余额",'年初余额'],
      headers1: ["负债和所有者权益", "期末余额",'年初余额'],
    };
  },
    computed: {
    ...mapGetters(["currClient", "currDate","currClientDetail"]),
  },
  mounted() {
    this.getData()
  },
  methods: {
       getData() {
      this.$store.commit('app/SET_LOADING_STATUS', true)
      this.tableData = [];
      let params = {
        ym: this.currDate,
        as_id:this.currClientDetail.as_id,
      };
      this.$axios.post("/report/balance-sheet", params).then(res => {
        console.log('利润表',res)
        if (res.success && res.rows) {
           this.tableData =  res.rows.map(item => {
             return {
                    title: item.assets,
                    value: item.end_balance,
                    value2: item.begin_balance,
                    align: "around",
                    color: "blue",
                    filter: "toThousandFilterNoZero"
                }
          });
          this.tableData1 =  res.rows.map(item => {
             return {
                    title: item.liabilities_equity,
                    value: item.end_balance2,
                    value2: item.begin_balance2,
                    align: "around",
                    color: "blue",
                    filter: "toThousandFilterNoZero"
                }
          }).filter(item=>item.title);
        }
      }).finally(_=>{
          this.$store.commit('app/SET_LOADING_STATUS', false)
      });
    },
  }
};
</script>

<style lang='less'>
.balance-sheet{
  &-title{

  }
}
</style>




// WEBPACK FOOTER //
// src/components/views/financial-report/balance-sheet/index.vue